<ng-container *ngIf="resultTranslations$ | async as resultTranslations">
  <h3
    [innerHtml]="
      resultTranslations['OptionsTitle']
        | stringReplace: items.length.toString()
        | safeHtml
    "
  ></h3>
  <div
    *ngFor="let item of items"
    class="btn btn-block btn-hero btn-iconed btn-iconed-anthrazit-08-primary btn-iconed-left"
    (click)="selectItem(item)"
  >
    <div>{{ item.Name }}</div>
    <i aria-hidden="true" class="ml-auto ifc-custom ifc-arrow-right"></i>
  </div>
</ng-container>
